export default __webpack_public_path__ + "static/media/932.eb81ecbe.jpg";